import { DEFAULT_ROWS_PER_PAGE } from '@atlassian/cssxp-utils-entitlement';
import { SortDirection, PartnerSearchContext } from '@css-xp/ppc-graphtypes';

export const buildAggregatedOptions = (searchTerm?: string, partnerSearchContext?: string) => {
  return {
    groupBy: 'name.keyword',
    pageOptions: {
      cursor: null,
      size: DEFAULT_ROWS_PER_PAGE,
    },
    searchOptions: {
      query: searchTerm,
      searchContext: partnerSearchContext as PartnerSearchContext,
    },
    sortOptions: {
      key: 'name.keyword',
      direction: SortDirection.ASC,
    },
  };
};
